import produce from "immer";
import { handleActions, createAction } from "redux-actions";

export const debugUser = {
  name: "Gianmarco",
  lastname: "Simone",
  email: `gianmarcosimone89+${parseInt(Math.random() * 1000, 10)}@gmail.com`,
  vat: "05619950966",
  cf: "SMNGMR89R04B506D",
  org_name: "Primis Group",
  invites: ['gianmarco@mail.com'],
  codiceDestinatario: "1234",
  password: "abcdefghi",
  passwordConfirm: "abcdefghi"
}

export const debugState = {
  step: 1,
  planID: 1,
  paymentType: "YEAR",
  user: debugUser
}

export const selectPlan = createAction("CHOOSE_PLAN");
export const selectPaymentType = createAction("SELECT_PAYMENT_TYPE");
export const setStep = createAction("SET_STEP");

export const reducer = handleActions(
  {
    [selectPlan]: (state, action) =>
      produce(state, draft => {
        console.log('selectPlan', { action })
        draft.planID = action.payload;
      }),
    [selectPaymentType]: (state, action) =>
      produce(state, draft => {
        draft.paymentType = action.payload;
      }),
    [setStep]: (state, action) =>
      produce(state, draft => {
        draft.step = action.payload;
      }),
  },
  {}
);
